<template>
    <div class="flex h-screen overflow-y-hidden">
        <div id="sidebar" class="h-full">
            <button
                @click.prevent="setDisplaySidebar()"
                class="bg-themeColor rounded-xl py-2 px-4 text-white fixed top-5 right-5 text-xl z-50 md:hidden"
            >
                <i class="fas fa-bars"></i>
            </button>
            <slide-x-left-transition :duration="250" mode="out-in">
                <NavBar
                    class="min-h-screen"
                    :class="[
                        displaySidebar
                            ? 'z-40 absolute shadow md:flex'
                            : 'hidden md:flex'
                    ]"
                    @display-sidebar="setDisplaySidebar"
                    ref="navBar"
                ></NavBar>
            </slide-x-left-transition>
        </div>
        <div
            @click="hideSidebar()"
            class="w-full md:p-4 overflow-y-scroll"
            id="main"
            v-if="!loading"
        >
            <fade-transition :duration="400" origin="center">
                <router-view :key="$route.fullPath"></router-view>
            </fade-transition>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/UI/NavBar'
import { FadeTransition, SlideXLeftTransition } from 'vue2-transitions'
import { getToken, isSupported } from 'firebase/messaging'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'App',
    props: {
        lang: {
            type: String,
            required: false
        },
        vueAppBaseUrl: {
            type: String,
            required: true
        },
        vueAppBackendUrl: {
            type: String,
            required: true
        },
        vueAppBingKey: {
            type: String,
            required: false
        },
        vueAppMapboxAccessToken: {
            type: String,
            required: false
        },
        vueAppFirebaseCloudMessaging: {
            type: String,
            required: true
        },
        vueAppUrlSignaler: {
            type: String,
            required: false
        },
        vueAppThemeColor: {
            type: String,
            required: false
        },
        vueAppSecondaryColor: {
            type: String,
            required: false
        },
        vueAppTertiaryColor: {
            type: String,
            required: false
        },
        vueAppStandAlone: {
            type: Boolean,
            required: false
        }
    },
    components: {
        NavBar,
        FadeTransition,
        SlideXLeftTransition
    },
    data() {
        return {
            loading: true,
            displaySidebar: false,
            dataIsPushNotif: false
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowHeight = window.innerHeight
        })
    },
    updated() {
        this.checkRedirections()
    },
    computed: {
        ...mapState('auth', {
            isConnected: (state) => state.isConnected,
            weakConnection: (state) => state.weakConnection
        }),
        // get the state of isMessagingSupported from the store
        ...mapState({
            isMessagingSupported: (state) => state.isMessagingSupported
        }),
        width() {
            return document.documentElement.clientWidth
        }
    },
    created() {
        this.initApp()
        const style = document.createElement('style')
        style.innerHTML = `.text-themeColor {
              color:${this.vueAppThemeColor};
            }
            .bg-themeColor {
              background-color:${this.vueAppThemeColor} !important; //LTU
            }
            .hover-text-themeColor:hover {
              color:${this.vueAppThemeColor} !important;//LTU
            }
            .border-themeColor {
              border-color:${this.vueAppThemeColor} !important;
            }
            .hover-bg-themeColor:hover {
              background-color:${this.vueAppThemeColor} !important;//LTU
            }
            .text-secondaryColor {
              color:${this.vueAppSecondaryColor}!important;//LTU
            }
            .bg-secondaryColor {
              background-color:${this.vueAppSecondaryColor}!important;//LTU
            }
            .hover-text-secondaryColor:hover {
              color:${this.vueAppSecondaryColor}!important;//LTU
            }
            .hover-bg-secondaryColor:hover {
              background-color:${this.vueAppSecondaryColor}!important;//LTU
            }
            .text-tertiaryColor {
              color:${this.vueAppTertiaryColor}!important;//LTU
            }
            .bg-tertiaryColor {
              background-color:${this.vueAppTertiaryColor}!important;//LTU
            }
            .hover-text-tertiaryColor:hover {
              color:${this.vueAppTertiaryColor}!important;//LTU
            }
            .hover-bg-tertiaryColor:hover {
              background-color:${this.vueAppTertiaryColor}!important;//LTU
            }
            input[type=checkbox]:checked+.check.is-primary {
              background-color:${this.vueAppThemeColor} !important;
            }
            input[type=checkbox]:checked+.check.is-primary:after {
              background-color:${this.vueAppThemeColor} !important;
            }
            .step-item.is-active.is-primary::before {
              background:${this.vueAppThemeColor} !important;
            }
            .step-item.is-previous.is-primary::before {
              background:${this.vueAppThemeColor} !important;
            }
            .step-item.is-previous .step-link .step-marker {
              border-color:white !important;
              background-color:${this.vueAppThemeColor} !important;
            }
            .step-item.is-previous .step-link .step-marker span {
              color:white !important;
            }
            .step-item .step-link .step-marker {
              border-color:${this.vueAppThemeColor} !important;
              background-color:white !important;
            }
            .step-item:not(.is-active):not(.is-previous) .step-link .step-marker span {
              color: white !important;
            }
	          .step-item:not(.is-previous):not(.is-active) .step-link .step-marker {
              border-color:white !important;
              background-color:#b5b5b5 !important;
            }
            .step-item.is-active .step-link .step-marker span {
              color:${this.vueAppThemeColor} !important;
	          }
	          .step-item.is-active .step-link::before {
              color: green !important;
              background-color: orange !important;
            }
            .button.is-primary {
              background-color:${this.vueAppThemeColor} !important;
            }
            .pagination-link.is-current {
              background-color:${this.vueAppThemeColor} !important;
              border-color:white !important;
            }
            .fas:not(.fa-arrow-circle-right):not(.fa-arrow-circle-left):not(.fa-eye):not(.fa-bars){
              color:${this.vueAppThemeColor} !important;
            }
            .b-steps .steps + .step-content {
              padding: 0.3em !important;
            }
            .b-steps .steps .step-items .step-item.is-primary:after {
              background:${this.vueAppThemeColor} !important;
            }
            .i-success {
              border-color:${this.vueAppThemeColor} !important;
              background-color:${this.vueAppThemeColor} !important;
            }
            .tag {
              background-color:${this.vueAppThemeColor} !important;
             }
            `
        document.head.appendChild(style)
    },
    methods: {
        ...mapActions('post', ['getPosts', 'getPostsByToken']),
        initApp() {
            this.$store.commit('setLang', this.lang)
            this.$store.commit('setVueAppBackendUrl', this.vueAppBackendUrl)
            this.$store.commit('setVueAppBaseUrl', this.vueAppBaseUrl)
            this.$store.commit('setVueAppUrlSignaler', this.vueAppUrlSignaler)

            this.$store.commit(
                'setVueAppMapboxAccessToken',
                this.vueAppMapboxAccessToken
            )
            this.$store.commit('setVueAppBingKey', this.vueAppBingKey)
            this.$store.commit('setVueAppStandAlone', this.vueAppStandAlone)

            this.checkNotificationsAvailability()

            getToken(this.$messaging, {
                vapidKey: this.vueAppFirebaseCloudMessaging
            })
                .then((currentToken) => {
                    if (currentToken) {
                        this.$store.commit('setFirebaseToken', currentToken)
                        this.$refs.navBar.getDataIsPushNotif()
                        let endpoint
                        if (this.isConnected) {
                            endpoint = this.getPosts()
                        } else {
                            endpoint = this.getPostsByToken()
                                .then((response) => {
                                    if (
                                        response.data.posts &&
                                        response.data.posts.total > 0
                                    ) {
                                        this.$store.commit(
                                            'auth/setWeakConnection',
                                            true
                                        )
                                    }
                                })
                                .catch(() => {
                                    this.$store.commit(
                                        'auth/setWeakConnection',
                                        false
                                    )
                                })
                        }

                        endpoint
                            .catch((e) => {
                                this.$store.dispatch('toastError', e)
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    } else {
                        console.log(
                            'No registration token available. Request permission to generate one.'
                        )
                        this.$store.commit('auth/setWeakConnection', false)
                        this.loading = false
                    }
                })
                .catch((err) => {
                    console.log(
                        'An error occurred while retrieving token. ',
                        err
                    )
                    this.loading = false
                })
        },
        checkRedirections() {
            if (
                this.$route.query.redirectTo !== undefined &&
                this.$route.query.id !== undefined
            ) {
                this.$router.push({
                    path:
                        decodeURIComponent(this.$route.query.redirectTo) +
                        '/' +
                        this.$route.query.id
                })
            } else if (this.$route.query.redirectTo !== undefined) {
                this.$router.push({ path: decodeURIComponent(this.$route.query.redirectTo) })
            }
        },
        checkNotificationsAvailability() {
            isSupported().then((supported) => {
                if (!('Notification' in window)) {
                    this.$store.commit('setIsMessagingSupported', false)
                } else if (Notification.permission === 'granted') {
                    this.$store.commit('setIsMessagingSupported', supported)
                } else if (Notification.permission !== 'denied') {
                    Notification.requestPermission().then((permission) => {
                        if (permission === 'granted') {
                            this.$store.commit(
                                'setIsMessagingSupported',
                                supported
                            )
                        }
                    })
                } else {
                    this.$store.commit('setIsMessagingSupported', false)
                }
            })
        },
        setDisplaySidebar() {
            this.displaySidebar = !this.displaySidebar
        },
        hideSidebar() {
            if (this.displaySidebar) {
                this.displaySidebar = !this.displaySidebar
            }
        }
    }
}
</script>

<style>
.ck.ck-content ul,
.ck.ck-content ul li {
    list-style-type: inherit;
}

.ck.ck-content ol,
.ck.ck-content ol li {
    list-style-type: number;
}

.ck.ck-content ul,
.ck.ck-content ol {
    /* Default user agent stylesheet, you can change it to your needs. */
    padding-left: 20px;
}
html::-webkit-scrollbar {
    display: none;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
